export const PLACE_META_TYPES_FETCHED = 'PLACE_META_TYPES_FETCHED';
export const PLACE_META_TYPE_ADD = 'PLACE_META_TYPE_ADD';
export const PLACE_META_TYPE_UPDATE = 'PLACE_META_TYPE_UPDATE';
export const PLACE_META_TYPE_REMOVE = 'PLACE_META_TYPE_REMOVE';
export const EXTEND_PLACE_META_TYPE = 'EXTEND_PLACE_META_TYPE';
